import moment from "moment";
const useInsuredMaxStartDate = (amount: number, unit: moment.unitOfTime.DurationConstructor, skipThisDayWhenMidday: Boolean = true) => {
  const date = moment().add(amount, unit).startOf("day")
  if (skipThisDayWhenMidday && date.hour() > 12) {
    return date.add(1, 'd').toDate()
  }
  return date.toDate()
}

export default useInsuredMaxStartDate